export default {
    it: {
        "go-back": "Torna indietro",
        "new-quiz": "Inizia nuovo questionario",
        "torna-home": "ok! Torna in Homepage",
        "ticket-attivato-success": "<strong>Grazie.</strong>Il ticket è stato preso in carico dal sistema e sarà gestito dai nostri operatori, ti risponderemo non appena possibile",
        "ticket-attivato-error": "<strong>Errore durante l'attivazione del ticket.</strong>C'è stato un errorre durante l'attivazione del ticket. Riprova più tardi",

    },
    en: {
        "go-back": "Go back",
        "new-quiz": "Start new questionnaire",
        "torna-home": "ok! Go back to Homepage",
        "ticket-attivato-success": "<strong>Thank you.</strong>The ticket has been taken over by the system and will be managed by our operators, we will reply to you as soon as possible",
        "ticket-attivato-error": "<strong>Error during ticket's attivation.</strong>There was an error activating the ticket. Try later",

    }
}